import { useBroadcastMutation, invalidateAfterBroadcast } from "@/modules/core/mutations";
import type { BroadcastMode } from "@/modules/core/mutations";
import { QueryKeys } from "@/modules/core";
import type { AuthContextV2 } from "@/modules/core/types";
import type { Operation } from "../../../hive-tx";

export interface LockLarynxPayload {
  mode: "lock" | "unlock";
  amount: number;
}

export function useLockLarynx(username: string | undefined, auth?: AuthContextV2,
  broadcastMode?: BroadcastMode
) {
  return useBroadcastMutation<LockLarynxPayload>(
    ["wallet", "lock-larynx"],
    username,
    (payload) => {
      const json = JSON.stringify({ amount: payload.amount * 1000 });
      return [["custom_json", {
        id: payload.mode === "lock" ? "spkcc_gov_up" : "spkcc_gov_down",
        required_auths: [username!],
        required_posting_auths: [],
        json,
      }] as Operation];
    },
    async () => {
      await invalidateAfterBroadcast(auth?.adapter, broadcastMode, [
        QueryKeys.accounts.full(username),
        ["ecency-wallets", "asset-info", username],
        ["wallet", "portfolio", "v2", username]
      ]);
    },
    auth,
    'active',
    { broadcastMode }
  );
}
